<template>
  <div class="relative">
    <v-row>
      <v-col cols="6" class="mb-4">
        <h2 v-text="$t('exercise_service.step1.title')"></h2>
        <p
          v-for="(item, index) in $t('exercise_service.step1.description')"
          :key="index"
          v-text="item"
        />
      </v-col>
      <v-col cols="6" class="sticky d-flex justify-end">
        <v-btn light class="amber" @click="addNote">Add note</v-btn>
      </v-col>
    </v-row>

    <div class="service">
      <service-col
        v-model="list1"
        :all="all"
        title="Awareness"
        class="service__col"
        @editNote="editNote"
        @showNote="showNote"
      ></service-col>
      <service-col
        v-model="list2"
        :all="all"
        title="First contact"
        class="service__col"
        @editNote="editNote"
        @showNote="showNote"
      ></service-col>
      <service-col
        v-model="list3"
        :all="all"
        title="Engagement"
        class="service__col"
        @editNote="editNote"
        @showNote="showNote"
      ></service-col>
      <service-col
        v-model="list4"
        :all="all"
        title="Return"
        class="service__col"
        @editNote="editNote"
        @showNote="showNote"
      ></service-col>
      <service-col
        v-model="list5"
        :all="all"
        title="Ambassador"
        class="service__col"
        @editNote="editNote"
        @showNote="showNote"
      ></service-col>
      <service-col
        v-model="tray"
        :all="all"
        title="Tray"
        class="service__tray"
        @editNote="editNote"
        @showNote="showNote"
      ></service-col>
    </div>

    <v-row v-if="debug">
      <v-col cols="2">
        <p>All</p>
        <pre>
                  {{ all }}
                </pre
        >
      </v-col>
    </v-row>

    <bottom-navigation
      :save="true"
      :next="false"
      :prev="false"
      :gridView="false"
      :gridToggle="false"
      @save="saveExercise"
      @prev="prevStep"
      @next="nextStep"
    >
    </bottom-navigation>

    <v-dialog v-model="dialog" max-width="500">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title
          class="headline"
          v-text="$t('exercise_service.saved.title')"
        ></v-card-title>


        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>

        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'add'">
        <v-card-title>Add note</v-card-title>

        <v-card-text>
          <service-add @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card light v-if="dialogMode == 'show'">
        <v-card-text class="pa-10">
          <service-show :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == 'edit'">
        <v-card-title class="headline">Edit note</v-card-title>

        <v-card-text>
          <service-edit :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ServiceCol, ServiceAdd, ServiceEdit, ServiceShow } from "./service";

const fb = require("@/firebaseConfig.js");
export default {
  name: "UserService",
  data() {
    return {
      collection: fb.exServiceNotesCollection,
      returnRoute: "UserService",
      e1: 1,
      dialog: false,
      dialogMode: "",
      exercise: null,
      debug: false,
      componentReady: false,
      intervalId: null,
      items: [],
      all: [],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      list5: [],
      cardId: null,
      ids: [],
    };
  },
  components: {
    BottomNavigation,
    ServiceCol,
    ServiceAdd,
    ServiceEdit,
    ServiceShow,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    tray: {
      get() {
        let remainder = [];
        this.all.forEach((x) => {
          if (
            this.list1.some((y) => y.id == x.id) ||
            this.list2.some((y) => y.id == x.id) ||
            this.list3.some((y) => y.id == x.id) ||
            this.list4.some((y) => y.id == x.id) ||
            this.list5.some((y) => y.id == x.id)
          ) {
            console.warn("found in array");
          } else {
            remainder.push(x);
          }
        });
        return remainder;
      },
      set(val) {
        return val;
      },
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.init();
    next();
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let vm = this;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.intervalId = setInterval(function() {
        vm.checkStatus();
      }, 300);
    },
    checkStatus() {
      console.log("checking status");
      if (this.currentProjectModel && this.currentProjectModel.id) {
        this.componentReady = true;
        clearInterval(this.intervalId);
        this.loadNotes();
      }
    },
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    loadNotes() {
      console.log("load notes");
      let ref = this.collection.where(
        "pid",
        "==",
        `${this.currentProjectModel.id}`
      );
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        let mode = "";
        console.log("type", querySnapshot.docChanges()[0].type);
        if (
          querySnapshot.docChanges().length != querySnapshot.docs.length &&
          querySnapshot.docChanges()[0].type == "added"
        ) {
          mode = "add";
          let post = querySnapshot.docChanges()[0].doc.data();
          items.push(post);
        } else if (querySnapshot.docChanges()[0].type == "modified") {
          console.log("modified");
          mode = "modified";
          querySnapshot.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
        } else {
          mode = "all";
          querySnapshot.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
        }
        if (mode == "all" || mode == "add") {
          this.all = [...this.all, ...items];
        }
        if (mode == "modified") {
          this.all = [...items];
          // let tile = this.all.find((x) => x.id === items[0].id);
          // tile = items[0];
        }
      });
      this.getExercise();
    },
    getExercise() {
      console.log("get exercise");
      let ref = fb.serviceExCollection
        .where("pid", "==", `${this.currentProjectModel.id}`)
        .where("uid", "==", 'shared');
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
          console.log("type", querySnapshot.docChanges()[0].type);
          this.list1 = [...doc.list1];
          this.list2 = [...doc.list2];
          this.list3 = [...doc.list3];
          this.list4 = [...doc.list4];
          this.list5 = [...doc.list5];
          this.ids = [...doc.ids];
        });
        this.exercise = items[0];
      });
    },
    saveExercise(notify) {
      // check if exercise exists
      let ref;
      let vm = this;
      let ids = [];
      this.list1.map((x) => {
        ids.push({ id: x.id, list: "list1" });
      });
      this.list2.map((x) => {
        ids.push({ id: x.id, list: "list2" });
      });
      this.list3.map((x) => {
        ids.push({ id: x.id, list: "list3" });
      });
      this.list4.map((x) => {
        ids.push({ id: x.id, list: "list4" });
      });
      this.list5.map((x) => {
        ids.push({ id: x.id, list: "list5" });
      });
      this.tray.map((x) => {
        ids.push({ id: x.id, list: null });
      });
      console.log(ids);
      if (this.exercise == null) {
        ref = fb.serviceExCollection.doc();
      } else {
        ref = fb.serviceExCollection.doc(this.exercise.id);
      }
      ref
        .set({
          updatedOn: new Date(),
          id: ref.id,
          uid: 'shared',
          pid: this.currentProjectModel.id,
          list1: this.list1,
          list2: this.list2,
          list3: this.list3,
          list4: this.list4,
          list5: this.list5,
          all: this.all,
          ids: ids,
        })
        .then(() => {
          if (notify) {
            vm.dialogMode = "save";
            vm.dialog = true;
          }
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
    addNote() {
      this.dialogMode = "add";
      this.dialog = true;
    },
    editNote($event) {
      console.log("edit note", $event);
      this.dialogMode = "edit";
      this.cardId = $event;
      this.dialog = true;
    },
    showNote($event) {
      console.log("show note", $event);
      this.dialogMode = "show";
      this.cardId = $event;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
    },
  },
};
</script>
